import { Box, Container, Typography, Button, Grid, Card, CardContent } from '@mui/material';
import { Link } from 'react-router-dom';

function Home() {
  return (
    <Container maxWidth="md" sx={{ py: 4, minHeight: '100vh' }}>
      {/* Hero Section */}
      <Box sx={{ py: 8, textAlign: 'center' }}>
        <Typography
          variant="h2"
          sx={{
            fontWeight: 900,
            fontFamily: 'Montserrat, Roboto, sans-serif',
            color: 'white',
            fontSize: 'clamp(2rem, 6vw, 4rem)',
            mb: 2,
          }}
        >
          Make your photos legendary.
        </Typography>
        <Typography
          variant="h6"
          sx={{
            color: 'rgba(255,255,255,0.75)',
            maxWidth: 500,
            mx: 'auto',
            mb: 3,
          }}
        >
          Overlay iconic body silhouettes on any photo. Free. Instant. No signup.
        </Typography>
        <Button
          variant="contained"
          size="large"
          component={Link}
          to="/app"
          sx={{
            mt: 3,
            px: 4,
            py: 1.5,
            fontSize: '1.1rem',
            borderRadius: 3,
            backgroundColor: 'transparent',
            background: 'linear-gradient(135deg, #7C3AED, #EC4899)',
            color: 'white',
            fontWeight: 'bold',
            textDecoration: 'none',
            boxShadow: '0 4px 15px rgba(236,72,153,0.3)',
            '&:hover': {
              background: 'linear-gradient(135deg, #6D28D9, #DB2777)',
              boxShadow: '0 6px 20px rgba(236,72,153,0.4)',
            },
          }}
        >
          Try Nutscaper Free →
        </Button>
      </Box>

      {/* Preview Image Section */}
      <Box sx={{ my: 6, textAlign: 'center' }}>
        <img
          src="/img/landing.png"
          alt="Nutscaper app preview"
          style={{
            maxWidth: '100%',
            borderRadius: '20px',
            border: '1px solid rgba(255,255,255,0.12)',
            boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
          }}
        />
      </Box>

      {/* Features Section */}
      <Grid container spacing={3} sx={{ py: 6 }}>
        {/* Feature 1 */}
        <Grid size={{ xs: 12, sm: 4 }}>
          <Card
            sx={{
              background: 'rgba(255,255,255,0.06)',
              backdropFilter: 'blur(20px)',
              borderRadius: 4,
              p: 3,
              textAlign: 'center',
              color: 'white',
              border: '1px solid rgba(255,255,255,0.10)',
              boxShadow: 'none',
            }}
          >
            <CardContent>
              <Box sx={{ fontSize: '2.5rem', mb: 1 }}>📸</Box>
              <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'white', mb: 1 }}>
                Webcam or Upload
              </Typography>
              <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.75)' }}>
                Use your camera or upload any photo
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        {/* Feature 2 */}
        <Grid size={{ xs: 12, sm: 4 }}>
          <Card
            sx={{
              background: 'rgba(255,255,255,0.06)',
              backdropFilter: 'blur(20px)',
              borderRadius: 4,
              p: 3,
              textAlign: 'center',
              color: 'white',
              border: '1px solid rgba(255,255,255,0.10)',
              boxShadow: 'none',
            }}
          >
            <CardContent>
              <Box sx={{ fontSize: '2.5rem', mb: 1 }}>👤</Box>
              <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'white', mb: 1 }}>
                Choose a Silhouette
              </Typography>
              <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.75)' }}>
                Pick from our silhouette library and position it perfectly
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        {/* Feature 3 */}
        <Grid size={{ xs: 12, sm: 4 }}>
          <Card
            sx={{
              background: 'rgba(255,255,255,0.06)',
              backdropFilter: 'blur(20px)',
              borderRadius: 4,
              p: 3,
              textAlign: 'center',
              color: 'white',
              border: '1px solid rgba(255,255,255,0.10)',
              boxShadow: 'none',
            }}
          >
            <CardContent>
              <Box sx={{ fontSize: '2.5rem', mb: 1 }}>⬇️</Box>
              <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'white', mb: 1 }}>
                Download Instantly
              </Typography>
              <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.75)' }}>
                Save your nutscaped masterpiece in one click
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
}

export default Home;
